import { makeHttpRequest } from "@/shared";

export const saveRepair = async (sessionKey, { hasDevice = false } = {}) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/save`,
            method: "POST",
            data: { has_device: hasDevice },
        })
    ).data;

    return response;
};
